import React, { Component } from 'react';
// import "./listpayment.css"
class Photo extends Component {

    constructor(props){
        super(props)
        this.state ={

            deleteOpsion:false

        }
    }
    clickIfShow=()=>{
        // console.log("data=>>>>>>>>",this.props.data)
        this.props.clickIfShow1(this.props.data)
    }

    deleteIF=(e)=>{
        // console.log("click data")
        e.preventDefault()
        this.setState({
          deleteOpsion: true
        })
      }

      deleteClose=(e)=>{
        // console.log("click data")
        e.preventDefault()
        this.setState({
          deleteOpsion: false
        })
      }

      deletePhoto = (data) =>{
        // console.log("click data", data)
        this.props.deletePhoto(data)
        this.setState({
            deleteOpsion: false
          })
      }
      
  render() {
  
    // console.log("leight =====---->array", total)
    
    return (
        <div>
            
                {
                    this.state.deleteOpsion ?
                    <div className="Productdetail-image-delete">
                         <div class="card-image" style={{paddingTop: "5px"}}>
                                <figure class="image is-4by3 zoomOut" >
                                    <img src={this.props.photo} alt=""/>
                                </figure>
                        </div>
                  
                     <p style={{textAlign:"center",position:"relative",bottom:"120px",color:"#fff"}}>
                         <small>Are you sure to delete this delete</small>
                    </p> 
                    <a  onClick={() => this.deletePhoto(this.props.id)}>
                        <div class="card-content" style={{position:"relative",bottom:"160px",left:"30px"}}>
                            <div class="media">
                                 <a class="button is-danger" >Delete</a>
                            </div>
                        </div>

                        </a>
                        <a  onClick={ this.deleteClose} className="button is-success is-outlined" style={{position:"relative",bottom:"220px",left:"140px"}}>
                        
                        <span>Close</span>
                            <span class="icon is-small">
                            <i class="fas fa-times"></i>
                            </span>
                       

                        </a>
                    </div>
                    :
                    <div>
                        <div class="card ressource-card">
                            <div class="card-image" style={{paddingTop: "5px"}}>
                                <figure class="image is-4by3 zoomOut" >
                                    <img src={this.props.photo} alt=""/>
                                </figure>
                            </div>
                            <a  onClick={ this.deleteIF}>
                                <div class="card-content">
                                    <div class="media">
                                        <div class="media-content">
                                            <a class="button is-small  rounded">
                                            <i class="fas fa-trash-alt"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            </a>
                            
                        </div>
                    </div>
                }

         </div>

    )

}





}

export default Photo;


// WEBPACK FOOTER //
// ./src/component/company/photos.js